import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OrderAnalysicModel } from '@app/models/myoffice/order/order-analysic.model';

@Injectable({
  providedIn: 'root'
})
export class OrderAnalysisService {

  constructor(private _http: HttpClient) { }

  orderAnalysicByRank(year:string , userid: string, typesearch:string) {
    return this._http.get<OrderAnalysicModel[]>(`${environment.apiUrl}/order/analysis-rank?userid=${userid}&comid=${environment.comId}&typesearch=${typesearch}&year=${year}`);
  }

  orderAnalysicByAge(year:string , userid: string, typesearch:string) {
    return this._http.get<OrderAnalysicModel[]>(`${environment.apiUrl}/order/analysis-age?userid=${userid}&comid=${environment.comId}&typesearch=${typesearch}&year=${year}`);
  }

  orderAnalysicByMonth(year:string , userid: string, typesearch:string) {
    return this._http.get<OrderAnalysicModel>(`${environment.apiUrl}/order/analysis-month?userid=${userid}&comid=${environment.comId}&typesearch=${typesearch}&year=${year}`);
  }

  orderAnalysicByCate(year:string , userid: string, typesearch:string) {
    return this._http.get<OrderAnalysicModel[]>(`${environment.apiUrl}/order/analysis-cate?userid=${userid}&comid=${environment.comId}&typesearch=${typesearch}&year=${year}`);
  }

  orderAnalysicByProduct(year:string , userid: string, typesearch:string) {
    return this._http.get<OrderAnalysicModel[]>(`${environment.apiUrl}/order/analysis-product?userid=${userid}&comid=${environment.comId}&typesearch=${typesearch}&year=${year}`);
  }
 

}

